import React, { useState, useEffect, useRef, useCallback } from "react";
import { useToast } from "../../../Utils/toastContext";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import { useDispatch, useSelector } from "react-redux";
import { updateFormData } from "../../../Redux/store/onboardingFormSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { setStepStatus } from "../../../Redux/store/onboardingFormSlice";
import LabelWithStatus from "../../../Components/Onbaording/label-with-status";
import ReviewPopup from "../../../Components/Onbaording/review-popup";
import { clearFileIdsRedux } from "../../../Redux/store/userSlice";
import WebSocketComponent from "../../Admin-login/websocket";

const ProofInfo = ({ setCurrentStep }) => {
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus
  );
  const customerId = useSelector((state) => state.form.onboardingCustomer);

  const isInvitee = useSelector((state) => state.user.isInvitee);

  const stepStatus = useSelector((state) => state.form.stepStatus);
  const userId = useSelector((state) => state.user.userId);
  const fileDetails = useSelector((state) => state.user.fileDetails);
  const hasNotifiedRef = useRef(false);

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const { showToast } = useToast();
  const [uploadPic, setUploadPic] = useState("");
  const [showCamera, setShowCamera] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [animateCamera, setAnimateCamera] = useState(false);
  const [stream, setStream] = useState(null);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [preview, setPreview] = useState("/avatar.svg");
  const [profilePayloadFile, setProfilePayloadFile] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [capturedFile, setCapturedFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});

  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const UploadCSVApi = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/advisor/onboarding/customer/${customerId}/upload/file`;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUploadFile = useCallback(
    debounce(async (e, file) => {
      e.preventDefault();

      let toastMessage = null;
      try {
        const response = await UploadCSVApi(capturedFile);
        if (response.status == "201") {
          toastMessage = {
            message: "Document uploaded successfully",
            type: "success",
          };
          handleCloseCamera();
          setProfilePayloadFile({
            ...profilePayloadFile,
            value: response.data,
          });
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [capturedFile] // Dependencies
  );

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg"];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast("Please upload an image in PNG or JPEG format.", "error");
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast("File size must be less than 10MB.", "error");
      return;
    }
    if (file) {
      let toastMessage = null;
      setLoading(true);
      try {
        const response = await UploadCSVApi(file);
        if (response.status == "201") {
          toastMessage = {
            message: "Document uploaded successfully",
            type: "success",
          };
          const imageUrl = URL.createObjectURL(file);
          setPreview(imageUrl);
          setProfilePayloadFile({
            ...profilePayloadFile,
            value: response.data,
          });
          // setFile()
        }
      } catch (err) {
        setPreview("/avatar.svg");
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    event.target.value = "";
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };
  const handleDeleteFile = () => {
    setPreview("/avatar.svg");
    setUploadPic(null);
    setProfilePayloadFile({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    setCapturedFile(null);
  };
  const handleTakeSnap = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL("image/png");
    setPreview(dataUrl);
    const file = dataURLtoFile(dataUrl, "snapshot.png");
    setCapturedFile(file);
    // Convert base64 to File object

    //  handleCloseCamera();
  };
  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const handleCloseCamera = () => {
    setAnimateCamera(false); // start fade-out
    setTimeout(() => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        setStream(null);
      }
      setShowCamera(false); // hide modal after animation
    }, 300); // match duration-300
  };
  const startCamera = async () => {
    setShowCamera(true);
    setTimeout(() => setAnimateCamera(true), 10); // trigger fade-in animation
    try {
      const newStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      setStream(newStream);
    } catch (err) {
      console.error("Camera access error:", err);
    }
  };
  const handleContinue = (isFinal) => {
    if (!profilePayloadFile.value) {
      showToast("Please upload file", "error");
      return;
    }
    setLoading(true);
    handlesave(isFinal);
  };
  const handleBack = () => {
    setCurrentStep(2);
  };
  const handleReset = () => {
    setCurrentStep(1);
  };
  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/advisor/onboarding/liveness-proof/customer/${customerId}/submit`;
    let bodyData = {
      file_id: profilePayloadFile.value.file_id,
      file_name: profilePayloadFile.value.file_name,
      is_submitted: isFinal,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const sendNotificationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/advisor/onboarding/liveness-proof/customer/${customerId}/mobile/upload-notif`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const sendNotification = async () => {
    let toastMessage = null;
    try {
      const response = await sendNotificationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: "success",
        };
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
    dispatch(updateFormData({ field: "proofFile", value: file }));
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(4);
          toastMessage = {
            message: response.message,
            type: "success",
          };
          const responseStatus = await GetAPIcalls(
            `/v1/advisor/onboarding/customer/${customerId}/status`
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
        } else {
          toastMessage = {
            message:
              "Information has been saved successfully. Please submit to proceed further.",
            type: "success",
          };
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
    dispatch(updateFormData({ field: "proofFile", value: file }));
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/advisor/onboarding/liveness-proof/customer/${customerId}/verification/preview`
      );

      if (response.status == 200) {
        setPreview(
          response.data.document.value.presigned_url == ""
            ? "/avatar.svg"
            : response.data.document.value.presigned_url
        );
        setProfilePayloadFile(response.data.document);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    if (
      (!isInvitee &&
        stepStatus.length > 0 &&
        stepStatus[2].status != "DRAFT") ||
      (isInvitee && stepStatus.length > 0 && stepStatus[1].status != "DRAFT")
    )
      getDetails();
  }, [stepStatus]);
  useEffect(() => {
    if (fileDetails && fileDetails.value) {
      setProfilePayloadFile(fileDetails);
    }
  }, [fileDetails]);
  useEffect(() => {
    if (
      (!isInvitee &&
        !hasNotifiedRef.current &&
        stepStatus.length > 0 &&
        stepStatus[2]?.status === "DRAFT") ||
      (isInvitee &&
        !hasNotifiedRef.current &&
        stepStatus.length > 0 &&
        stepStatus[1]?.status === "DRAFT")
    ) {
      sendNotification();
      hasNotifiedRef.current = true;
    }
  }, [stepStatus]);
  useEffect(() => {
    if (
      (!isInvitee &&
        updateFieldStatus &&
        stepStatus.length > 0 &&
        stepStatus[2].status != "DRAFT") ||
      (isInvitee &&
        updateFieldStatus &&
        stepStatus.length > 0 &&
        stepStatus[1].status != "DRAFT")
    ) {
      getDetails();
    }
  }, [updateFieldStatus, stepStatus]);
  // assign stream to video after it's rendered
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }
  }, [stream]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)]   lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {((!isInvitee &&
          stepStatus.length > 0 &&
          (stepStatus[2].status == "IN_REVIEW" ||
            stepStatus[2].status == "COMPLETED")) ||
          (isInvitee &&
            stepStatus.length > 0 &&
            (stepStatus[1].status == "IN_REVIEW" ||
              stepStatus[1].status == "COMPLETED"))) && (
          <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
            <img
              src="/warning-circle.svg"
              alt="Info"
              className="w-4 h-4 mr-2"
            />
            <span>
              This section is <strong>in review by our onboarding team</strong>.
              You will be notified once the verification is complete.{" "}
            </span>
          </div>
        )}
        {((!isInvitee &&
          stepStatus.length > 0 &&
          stepStatus[2].status == "APPROVED") ||
          (isInvitee &&
            stepStatus.length > 0 &&
            stepStatus[1].status == "APPROVED")) && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className=" border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2">
              <img
                src="/camera.svg"
                alt="User Avatar"
                className="h-6 w-6 mb-2"
              />
              <h1 className="text-xl font-medium mb-2">Prove Its You</h1>
            </div>
            <li className="text-xs ml-2 font-medium text-black">
              Please ensure that the image you upload is clear and that any text
              in it is easily readable.
            </li>{" "}
            <li className="text-xs ml-2 font-medium text-black">
              Your face should be visible without obstruction, and avoid dim
              lighting or wearing items such as caps, masks, or any clothing
              that conceals your face.
            </li>
            <li className="text-xs ml-2 font-medium text-[#FF5050]">
              If you need to adjust any information from the previous section,
              please click on the “Reset Application” button
            </li>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {/* LEFT SECTION: Upload */}
            <div className="col-span-2 px-4 pt-2 border-gray-300 md:border-r">
              <div className="flex flex-col px-2">
                <div className="flex items-center justify-between">
                  <LabelWithStatus
                    id="proveYou"
                    label="Prove It's You"
                    required={true}
                    fieldData={profilePayloadFile}
                    handleStatusClick={handleStatusClick}
                  />
                </div>
                {/* Upload Area */}
                {preview == "/avatar.svg" && (
                  <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                    <input
                      type="file"
                      id="fileUpload"
                      accept=".png,.jpeg"
                      onChange={handleFileChange}
                      className="hidden"
                    />
                    <img
                      src="/folder-add.svg"
                      alt="Upload Icon"
                      className="h-4 w-4"
                    />
                    <p className="mt-2 text-gray-500 text-sm">
                      Drag & Drop <br />
                      or <span className="underline">Click to Upload</span>
                    </p>
                  </label>
                )}
                {preview != "/avatar.svg" && (
                  <label className="border-2 border-dashed rounded-lg p-2 mt-2 block text-center cursor-pointer flex flex-col items-center">
                    <img src={preview} alt="Avatar" className="w-30 h-30" />
                  </label>
                )}
                <div className="mt-1 flex flex-wrap gap-2">
                  <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                <div className="flex flex-wrap gap-4 mt-2">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                  <button
                    onClick={handleUploadClick}
                    className="bg-white text-black border-black border-2 text-xs px-3 py-1 rounded-full"
                  >
                    Upload from Device
                  </button>
                  <button
                    onClick={() => {
                      setPreview("");
                      setUploadPic(null);
                      setProfilePayloadFile({
                        verification_id: null,
                        value: null,
                        status: "pending",
                        rejection_reason: null,
                        rejection_comment: null,
                        rejection_timestamp: null,
                        rejected_by: null,
                        comments: [],
                      });
                      setCapturedFile(null);
                      startCamera();
                    }}
                    className="bg-black text-white text-xs px-3 py-1 rounded-full flex items-center gap-2"
                  >
                    <img
                      src="/camera-black.svg"
                      alt="Camera Icon"
                      className="w-4 h-4"
                    />
                    Take Snap
                  </button>
                </div>
                {profilePayloadFile.value && (
                  <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        handleFileClick(e, profilePayloadFile.value);
                      }}
                      className="flex-col flex"
                    >
                      <span className="text-black underline cursor-pointer">
                        {profilePayloadFile.value.file_name}
                      </span>
                      <span className="text-[#46DA55] text-xs">
                        Upload Completed
                      </span>
                    </div>
                    <button
                      onClick={handleDeleteFile}
                      className="text-red-500 font-semibold"
                    >
                      <img
                        src="/trash.svg"
                        alt="Delete Icon"
                        className="h-6 w-6"
                      />
                    </button>
                  </div>
                )}
                {showCamera && (
                  <div
                    className={`fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out ${
                      animateCamera ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    <div
                      className={`relative transform transition-transform duration-300 ease-in-out bg-white rounded-xl p-4 w-full max-w-md flex flex-col items-center ${
                        animateCamera ? "scale-100" : "scale-90"
                      }`}
                    >
                      {/* Preview or Live Camera */}
                      {preview === "" ? (
                        <video
                          ref={videoRef}
                          autoPlay
                          playsInline
                          className="w-full h-auto rounded shadow-lg"
                        />
                      ) : (
                        <div className="relative w-full">
                          <img
                            src={preview}
                            alt="Avatar"
                            className="w-full h-auto rounded shadow-lg"
                          />
                          <button
                            onClick={() => {
                              setPreview("");

                              setUploadPic(null);
                              setProfilePayloadFile({
                                verification_id: null,
                                value: null,
                                status: "pending",
                                rejection_reason: null,
                                rejection_comment: null,
                                rejection_timestamp: null,
                                rejected_by: null,
                                comments: [],
                              });
                              setCapturedFile(null);
                              startCamera();
                            }}
                            className="absolute top-2 right-2 bg-white hover:bg-gray-100 p-1 rounded-full shadow-md transition"
                            aria-label="Remove preview"
                          >
                            <img
                              src="/trash.svg"
                              alt="Delete"
                              className="w-4 h-4"
                            />
                          </button>
                        </div>
                      )}

                      {/* Action Buttons */}
                      <div className="flex flex-wrap justify-center gap-4 mt-4">
                        <button
                          onClick={() => {
                            if (preview == "") {
                              setPreview("/avatar.svg");
                            }
                            if (
                              preview != "" &&
                              profilePayloadFile.value == null
                            ) {
                              setPreview("/avatar.svg");
                            }
                            handleCloseCamera();
                          }}
                          className="bg-white text-black border-black border-2 text-sm px-4 py-2 rounded-full"
                        >
                          Cancel
                        </button>
                        {preview === "" && (
                          <>
                            <button
                              onClick={handleTakeSnap}
                              className="bg-black text-white text-sm px-4 py-2 rounded-full"
                            >
                              Capture Photo
                            </button>
                          </>
                        )}
                        {preview !== "" && (
                          <>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                setLoading(true);
                                handleUploadFile(e);
                              }}
                              className="bg-black text-white text-sm px-4 py-2 rounded-full"
                            >
                              Upload Photo
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <canvas ref={canvasRef} className="hidden" />
              </div>
            </div>
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={currentDocument.presigned_url}
                fileName={currentDocument.file_name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
            {/* RIGHT SECTION: Photo Guide */}
            <div className="col-span-3 pr-2 pt-2">
              <div className="flex flex-col md:flex-row">
                {/* Guide Section */}
                <div className="flex flex-col items-center text-center mb-6 md:mb-0 mr-2">
                  <p className="text-md font-semibold text-labelColour">
                    Photo Guide
                  </p>
                  <img
                    src="/gg.svg"
                    alt="Photo Guide"
                    className="w-50 h-50 object-contain"
                  />
                </div>
                {/* Do Not Section */}
                <div className="flex flex-col w-full md:w-3/4">
                  <p className="text-md font-semibold text-labelColour text-center md:text-left">
                    Do Not Follow
                  </p>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-1">
                    <div className="w-[40]">
                      <img
                        src="/firstNot.svg"
                        alt="Do Not 1"
                        className="w-full h-90 object-contain"
                      />
                    </div>
                    <div className="w-[40]">
                      <img
                        src="/secondNot.svg"
                        alt="Do Not 2"
                        className="w-full h-90 object-contain "
                      />
                    </div>
                    <div className="w-[40]">
                      <img
                        src="/thirdNot.svg"
                        alt="Do Not 3"
                        className="w-full h-90 object-contain"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WebSocketComponent userId={userId} />
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      {/* Footer always at the bottom */}
      <footer className="flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        {((!isInvitee &&
          stepStatus.length > 2 &&
          stepStatus[2]?.status !== "COMPLETED" &&
          stepStatus[2]?.status !== "APPROVED" &&
          stepStatus[2]?.status !== "IN_REVIEW") ||
          (isInvitee &&
            stepStatus.length > 1 &&
            stepStatus[1]?.status !== "COMPLETED" &&
            stepStatus[1]?.status !== "APPROVED" &&
            stepStatus[1]?.status !== "IN_REVIEW")) && (
          <>
            <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
              <ConfirmResetButton onConfirm={handleReset} onBack={handleBack} />
            </div>
            <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
              <div className="w-full md:w-auto flex justify-center md:justify-end">
                <button
                  onClick={() => {
                    handleContinue(false);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Save as Draft</span>
                </button>
              </div>
              <ConfirmContinueButton
                onContinue={() => handleContinue(true)}
                buttonText="Continue"
                confirmTitle="Save Section"
                confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
              />
            </div>
          </>
        )}
        {((!isInvitee &&
          stepStatus.length > 0 &&
          (stepStatus[2].status == "COMPLETED" ||
            stepStatus[2].status == "APPROVED" ||
            stepStatus[2].status == "IN_REVIEW")) ||
          (isInvitee &&
            stepStatus.length > 0 &&
            (stepStatus[1].status == "COMPLETED" ||
              stepStatus[1].status == "APPROVED" ||
              stepStatus[1].status == "IN_REVIEW"))) && (
          <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
            {/* Save as Draft */}
            <button
              onClick={() => {
                if (isInvitee) {
                  setCurrentStep(3);
                } else {
                  setCurrentStep(4);
                }
              }}
              className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Next</span>
            </button>
          </div>
        )}
      </footer>
    </div>
  );
};

export default ProofInfo;
